import { TenantSelectionMessages, TranslationTenantSelectionMessages } from "../interfaces";

export const messages: TranslationTenantSelectionMessages = {
  [TenantSelectionMessages.title]: "Selecione o tenant que deseja acessar",
  [TenantSelectionMessages.currentTenant]: "Tenant atual: {{currentTenantName}}",
  [TenantSelectionMessages.confirmTenantSelectionModalTitle]: "Alteração de tenant",
  [TenantSelectionMessages.confirmTenantSelectionModalContent]: "Ao confirmar a seleção de um novo tenant,"
  + " você será deslogado automaticamente para aplicar as mudanças. Deseja continuar?"

};